export const ENTITY_PROCEDURE_SECTION_ID = 'consultas-e-horarios';
